"use strict";

exports.__esModule = true;
exports.default = cleanProps;

var _immer = _interopRequireDefault(require("immer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var names = ['delay', 'onDatumBind', 'rules', 'formDatum', 'forceChange', 'trim', 'beforeChange', 'validateHook', 'innerFormNamePath', 'fieldSetValidate', 'combineRules'];
/**
 * delete some props if needed, will not modify the pass argument
 * @param props
 * @returns {Produced<*, *>}
 */

function cleanProps(props) {
  return (0, _immer.default)(props, function (draft) {
    names.forEach(function (p) {
      return delete draft[p];
    });
  });
}